export default __webpack_public_path__ + "static/media/5 - Детские развивающие кружки.072dc16f.jpg";